import { styled } from '@mui/material'
import Box from '@mui/system/Box'

const Halo = styled(Box)`
  background: #bfff0b;
  opacity: 0.5;
  filter: blur(100px);

  width: 100%;
  height: 294px;
  z-index: -1;
  position: absolute;
  top: 100px;
`

export default Halo
